import StatusChip from "@entrilia/shared/components/StatusChip";

const LiveStatus = () => <StatusChip label="Live" withDot color={(t) => t.palette.success.main} />;

export default LiveStatus;
